import styled from "styled-components";

export const TextareaWrapper = styled.div`
  position: relative;
  width: 100%;
  display: flex;
`;

export const StyledTextarea = styled.textarea`
  width: 100%;
  appearance: unset;
  color: var(--text-color-primary);
  font-size: 16px;
  border: 1px solid var(--border-color);
  outline: 1px solid transparent;
  border-radius: 10px;
  background-color: var(--theme-color-secondary);
  padding: 14px 12px;
  transition: all ease-in-out 0.3s;

  &::placeholder {
    color: var(--text-color-secondary);
    opacity: 0.6;
    font-size: 14px;
  }

  &:focus {
    border-color: var(--theme-color-primary);
    outline-color: var(--theme-color-primary);
  }

  &:disabled {
    cursor: not-allowed;
    color: var(--text-color-secondary);
  }
`;